import App from './App.vue'
import {createVueApp, initializeFabricTheme} from "./vueUtil";
import 'primeicons/primeicons.css'
import "./css/tailwind.css";
import './css/app.css'
import './css/fabric-fluent-theme.css';
import './css/bpmn-font/css/bpmn.css';
import './css/pac-font/style.css';
import './css/diagram-js.css';
import './css/diagram-js-minimap.css';

async function bootstrap() {
    await initializeFabricTheme();
    const app = createVueApp(App)
    app.mount('#app')
}

bootstrap().catch((error) => {
    console.error('[Bootstrap] Application startup aborted because Fabric theme initialization failed.', error);
});

if (!String.prototype.splice) {
    /**
     * {JSDoc}
     *
     * The splice() method changes the content of a string by removing a range of
     * characters and/or adding new characters.
     *
     * @this {String}
     * @param {number} start Index at which to start changing the string.
     * @param {number} delCount An integer indicating the number of old chars to remove.
     * @param {string} newSubStr The String that is spliced in.
     * @return {string} A new string with the spliced substring.
     */
    String.prototype.splice = function(start, delCount, newSubStr) {
        return this.slice(0, start) + newSubStr + this.slice(start + Math.abs(delCount));
    };
}